
const state = {
  deep_link_id: undefined,
  id: null,
  product_code: '',
  provider_id: undefined,
  service_product_id: undefined,
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'service_product_id' },
]

export default state
